import {useEffect, useRef, useState} from 'react';

export interface TypeEffectProps {
  delay?: number;
  interval?: number;
  onEnd?: () => void;
  text: string;
}

export const TypeEffect = ({delay = 0, interval = 25, onEnd, text}: TypeEffectProps) => {
  const cursor = useRef(0);
  const [writtenText, setWrittenText] = useState('');
  const onEndRef = useRef(onEnd);
  onEndRef.current = onEnd;

  useEffect(() => {
    let intervalId: number;

    const timeoutId = setTimeout(() => {
      intervalId = window.setInterval(() => {
        if (cursor.current < text.length) {
          setWrittenText(text.substring(0, cursor.current + 1));
          cursor.current++;
        } else {
          onEndRef.current?.();
          clearInterval(intervalId);
        }
      }, interval);
    }, delay);

    return () => {
      cursor.current = 0;
      clearInterval(intervalId);
      clearTimeout(timeoutId);
      setWrittenText('');
    };
  }, [delay, interval, text]);

  return <>{writtenText}</>;
};
